import { KineProvider } from "../providers/KineProvider";
import { NewApplicationProvider } from "../providers/NewApplicationProvider";
import { Outlet } from "react-router-dom";
import PlaygroundBanner from "../components/PlaygroundBanner";


const ApplicationForm = () => {

    return (
        <p>Application form</p>
    )
}

export function ApplicationFormContainer({ sandbox = false }: { sandbox?: boolean }) {
    return (
        <NewApplicationProvider sandbox={sandbox}>
            <KineProvider>
                {sandbox && <PlaygroundBanner />}
                <Outlet />
            </KineProvider>
        </NewApplicationProvider>
    )
}

export default ApplicationForm;
